module.exports = __webpack_public_path__ + "static/14-038ad05ec52bf5fa976af3af8336a9b1.png";